import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { images } from '../mockData';

export const About = ({ t }) => {
  const stats = [
    { value: t.aboutStat1, label: t.aboutStat1Label },
    { value: t.aboutStat2, label: t.aboutStat2Label },
    { value: t.aboutStat3, label: t.aboutStat3Label }
  ];

  return (
    <section className="py-20 bg-brand-lightPink/30 relative overflow-hidden">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold font-serif text-brand-navy mb-4">
            {t.aboutTitle}
          </h2>
          <p className="text-xl text-brand-pink font-semibold">
            {t.aboutSubtitle}
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform transition-transform duration-300 hover:scale-105">
              <video
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                role="img"
                aria-label="Fresh desi milk being poured into a traditional can at RajDarshan Farms — farm-to-home pure milk process in Raipur"
                title="Desi milk extraction and collection — RajDarshan Tandon Dairy heritage since 1969"
                className="w-full h-[400px] object-cover"
              >
                <source src="/desimilkincanCOMPRESSED.mp4" type="video/mp4" />
              </video>
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/50 to-transparent"></div>
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-xl border-4 border-brand-pink/20">
              <p className="text-3xl font-bold font-serif text-brand-navy">1969</p>
              <p className="text-sm text-brand-navy/70 font-semibold">Since</p>
            </div>
          </div>

          {/* Description */}
          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              {t.aboutDesc}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4">
              {stats.map((stat, index) => (
                <Card key={index} className="text-center border-2 border-brand-lightBlue bg-white/80 backdrop-blur-sm hover:shadow-lg transition-shadow duration-200">
                  <CardContent className="pt-6">
                    <p className="text-3xl font-bold text-brand-pink mb-2">
                      {stat.value}
                    </p>
                    <p className="text-sm text-brand-navy/70 font-medium">
                      {stat.label}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Link
        to="/milk-subscription-raipur"
        className="pill-float-1 inline-flex items-center gap-2 bg-brand-navy text-white text-sm font-bold px-5 py-2.5 rounded-full shadow-xl border-2 border-brand-pink/40 cursor-pointer no-underline transition-all duration-200"
      >
        <span>🥛</span> Subscription Model <span className="ml-1 text-brand-pink">→</span>
      </Link>

    </section>
  );
};
